import { rootApi } from './baseApi';

export type TicketType = 'bug' | 'feature_request' | 'other';
export type TicketStatus = 'open' | 'under_review' | 'in_progress' | 'completed' | 'wont_fix';

export interface TicketUpdate {
  id: number;
  ticket_id: number;
  author_name: string;
  is_admin: boolean;
  message: string;
  new_status: TicketStatus | null;
  created_at: string;
}

export interface SupportTicket {
  id: number;
  company_id: number;
  company_name: string;
  user_id: number;
  user_email: string;
  user_name: string;
  type: TicketType;
  title: string;
  description: string;
  status: TicketStatus;
  created_at: string;
  updated_at: string;
  updates: TicketUpdate[];
}

export const supportTicketApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getSupportTickets: builder.query<SupportTicket[], void>({
      query: () => '/support-tickets',
      providesTags: ['SupportTickets'],
    }),
    createSupportTicket: builder.mutation<SupportTicket, { type: TicketType; title: string; description: string }>({
      query: body => ({ url: '/support-tickets', method: 'POST', body }),
      invalidatesTags: ['SupportTickets'],
    }),
    addTicketUpdate: builder.mutation<TicketUpdate, { id: number; message: string; new_status?: TicketStatus }>({
      query: ({ id, ...body }) => ({ url: `/support-tickets/${id}/updates`, method: 'POST', body }),
      invalidatesTags: ['SupportTickets'],
    }),
    deleteTicket: builder.mutation<void, number>({
      query: id => ({ url: `/support-tickets/${id}`, method: 'DELETE' }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          supportTicketApi.util.updateQueryData('getSupportTickets', undefined, draft => {
            const idx = draft.findIndex(t => t.id === id);
            if (idx !== -1) draft.splice(idx, 1);
          })
        );
        try { await queryFulfilled; } catch { patch.undo(); }
      },
      invalidatesTags: ['SupportTickets'],
    }),
  }),
});

export const {
  useGetSupportTicketsQuery,
  useCreateSupportTicketMutation,
  useAddTicketUpdateMutation,
  useDeleteTicketMutation,
} = supportTicketApi;
